export default __webpack_public_path__ + "static/Stuart-Henderson-Evrchat-8f749318cce0f2fb100e9d087c3f68b8.jpg";